import { configureStore } from "@reduxjs/toolkit";

import venuesReducer from "../pages/Venues/sliceReducer";
import userReducer from "./Reducers/userReducer";
import teamsReducer from "../pages/Teams/sliceReducer";
import commonReducer from "./Reducers/commonReducer";
import adsReducer from "../pages/Ads/sliceReducer";
import governingBodiesReducer from "../pages/GoverningBodies/sliceReducer";
import qualifyingScoresReducer from "../pages/QualifyingScores/sliceReducer";
import mapsAutofillReducer from "./Reducers/mapsAutofillReducer";
import ruleCatalogReducer from "./Reducers/ruleCatalogReducer";

export const store = configureStore({
  reducer: {
    venues: venuesReducer,
    user: userReducer,
    teams: teamsReducer,
    ads: adsReducer,
    governingBodies: governingBodiesReducer,
    qualifyingScores: qualifyingScoresReducer,
    mapsAutofill: mapsAutofillReducer,
    ruleCatalog: ruleCatalogReducer,
    common: commonReducer,
  },
});
